import { styled } from 'styled-components';

const TipBillPageStyled = styled.div`
  background-color: #e5e5e5;
  height: 100vh;
  position: relative;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .group-btn-print-tip-bill {
    top: 1.5rem;
    right: 2.5rem;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18rem;
    column-gap: 1.5rem;
  }
`;

export default TipBillPageStyled;
